
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { motion } from "framer-motion";
import { Button } from "./ui/button";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="text-xl font-bold text-primary">
              Candidatura El Coto
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-4">
            <Link
              to="/"
              className="text-gray-700 hover:text-primary transition-colors"
            >
              Inicio
            </Link>
            <Link
              to="/equipo"
              className="text-gray-700 hover:text-primary transition-colors"
            >
              Equipo Gestor
            </Link>
            <Link
              to="/planes"
              className="text-gray-700 hover:text-primary transition-colors"
            >
              Planes y Logros
            </Link>
            <Link
              to="/votar"
              className="text-gray-700 hover:text-primary transition-colors"
            >
              Cómo Votar
            </Link>
            <Link
              to="/participar"
              className="text-gray-700 hover:text-primary transition-colors"
            >
              Participa
            </Link>
          </div>

          {/* Mobile Navigation Button */}
          <div className="md:hidden flex items-center">
            <Button
              variant="ghost"
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2"
            >
              {isOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </Button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="md:hidden"
          >
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              <Link
                to="/"
                className="block px-3 py-2 rounded-md text-gray-700 hover:text-primary hover:bg-gray-50"
                onClick={() => setIsOpen(false)}
              >
                Inicio
              </Link>
              <Link
                to="/equipo"
                className="block px-3 py-2 rounded-md text-gray-700 hover:text-primary hover:bg-gray-50"
                onClick={() => setIsOpen(false)}
              >
                Equipo Gestor
              </Link>
              <Link
                to="/planes"
                className="block px-3 py-2 rounded-md text-gray-700 hover:text-primary hover:bg-gray-50"
                onClick={() => setIsOpen(false)}
              >
                Planes y Logros
              </Link>
              <Link
                to="/votar"
                className="block px-3 py-2 rounded-md text-gray-700 hover:text-primary hover:bg-gray-50"
                onClick={() => setIsOpen(false)}
              >
                Cómo Votar
              </Link>
              <Link
                to="/participar"
                className="block px-3 py-2 rounded-md text-gray-700 hover:text-primary hover:bg-gray-50"
                onClick={() => setIsOpen(false)}
              >
                Participa
              </Link>
            </div>
          </motion.div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
